/*
 * Toast helpers for the tenant console.
 *
 * `notifySuccess`/`notifyInfo` in sdk-ui take `(message, title)` only, so any
 * toast that needs a button has to drop down to `show()`. Every "…, undo?"
 * surface in this app wants the same shape, and the reviews in
 * `_UI_improvements/tenant` ask for it repeatedly (a destructive or
 * hard-to-find action should be reversible from the toast that reports it),
 * so it lives here once rather than being rebuilt per page.
 */
import { show } from '@repletoryreach/sdk-ui/feedback';

export interface UndoToastOptions {
  /** What happened, in the past tense. */
  message: string;
  /** Label for the undo button, translated by the caller. */
  undoLabel: string;
  /** Reverses the action. */
  onUndo: () => void;
  /** Longer than the default so there is time to read it and react. */
  durationMs?: number;
}

/** An "…, undo?" toast. Returns the notification id. */
export function notifyUndo({ message, undoLabel, onUndo, durationMs = 8000 }: UndoToastOptions): string {
  return show({
    type: 'info',
    message,
    durationMs,
    action: { label: undoLabel, onClick: onUndo }
  });
}
